import React, { useState, useContext } from "react";
import { Typography, InputBase, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import storeApi from "../../utils/storeApi";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const useStyle = makeStyles((theme) => ({
  editableTitleContainer: {
    margin: theme.spacing(1),
    display: "flex",
    position: "relative",
  },
  editableTitle: {
    // flexGrow: 1,
    // fontSize: '1.2rem',
    fontSize: "0.975rem",
    fontWeight: "bold",
  },
  input: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    margin: theme.spacing(1),
    "&:focus": {
      background: "#ddd",
    },
  },
}));
export default function Title({
  title,
  listId,
  totalizadorAtrasados,
  ocultarUsuario,
}) {
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const { updateListTitle } = useContext(storeApi);
  const classes = useStyle();
  const handleOnChange = (e) => {
    setNewTitle(e.target.value);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOption1 = (idUsuario) => {
    ocultarUsuario(idUsuario);
    handleClose();
  };

  // const handleOnBlur = () => {
  //   updateListTitle(newTitle, listId);
  //   setOpen(false);
  // };
  return (
    <div>
      {open ? (
        <div>
          <InputBase
            onChange={handleOnChange}
            autoFocus
            value={newTitle}
            inputProps={{
              className: classes.input,
            }}
            fullWidth
            // onBlur={handleOnBlur}
          />
        </div>
      ) : (
        <div className={classes.editableTitleContainer}>
          <Typography
            // onClick={() => setOpen(!open)}
            className={classes.editableTitle}
          >
            {title}
          </Typography>

          {totalizadorAtrasados > 0 && (
            <React.Fragment>
              &nbsp;&nbsp;
              <Tooltip title="Tickets atrasados" arrow placement="right">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#f22d4e",
                    minWidth: "20px",
                    minHeight: "20px",
                    borderRadius: "4px",
                    border: "1px solid #ffffff88",
                    color: "#FFF",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {totalizadorAtrasados}
                </div>
              </Tooltip>
            </React.Fragment>
          )}

          <div style={{ position: "absolute", right: 0 }}>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreHorizIcon />
            </IconButton>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => handleOption1(listId)}>
                Ocultar Usuário
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>Cancelar</MenuItem> */}
            </Menu>
          </div>
        </div>
      )}
    </div>
  );
}
